import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import parse from 'html-react-parser';
// conponents
import Accordion from 'react-bootstrap/Accordion';
import Image from '../image/Image';
import TrustpilotWidget from './trustpilot-widget';
// content
import footerData from './footer-content';
import { trademark } from '../../documents/disclosures/regulatory';
// scripts
import { placeholderDarker } from '../../scripts/media';
import { appStoreAppLink, googlePlayAppLink, sharedLogosPath } from '../../scripts/data';
import CustomLink from '../custom-link/CustomLink';
var Footer = /*#__PURE__*/function (_React$Component) {
  function Footer() {
    _classCallCheck(this, Footer);
    return _callSuper(this, Footer, arguments);
  }
  _inherits(Footer, _React$Component);
  return _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this = this;
      var id = 'footer';
      var footerDataUpdated = function footerDataUpdated() {
        return footerData.mainCols.map(function (col) {
          var newCol = _objectSpread({}, col);
          newCol.links = newCol.links.filter(function (el) {
            if (_this.props.homepage) {
              return Object.prototype.hasOwnProperty.call(el, 'homepage') && el.homepage || !Object.prototype.hasOwnProperty.call(el, 'homepage');
            }
            return Object.prototype.hasOwnProperty.call(el, 'homepage') && !el.homepage || !Object.prototype.hasOwnProperty.call(el, 'homepage');
          });
          return newCol;
        }).slice(0, _this.props.homepage ? undefined : -1); // Remove the last element if not homepage
      };
      var returnFootNote = function returnFootNote() {
        return _this.props.tradeMarkFootNote ? parse(_this.props.tradeMarkFootNote) : '';
      };
      return React.createElement("footer", {
        id: id,
        className: "bg-light pt-6 pt-md-7 pt-lg-8"
      }, React.createElement("div", {
        className: "container "
      }, React.createElement(Accordion, {
        alwaysOpen: true,
        flush: true,
        className: "d-lg-flex links-unstyled justify-content-lg-between accordion-lg-none accordion-angle-icon"
      }, !this.props.homepage ? React.createElement("div", {
        className: "d-md-flex d-lg-block col-lg-3 mb-5 mb-lg-0"
      }, React.createElement(CustomLink, {
        isLink: this.props.pageType === 'product',
        href: "/",
        className: "d-block mb-4 mb-md-0 mb-lg-4 me-md-4 me-lg-0 flex-shrink-0"
      }, React.createElement(Image, {
        src: "".concat(sharedLogosPath, "/logo-experian.svg"),
        alt: "Experian logo.",
        width: "120",
        height: "40",
        className: "img-fluid exp-logo"
      })), React.createElement("p", {
        className: "text-gray mb-0"
      }, "Experian is a globally recognized financial leader committed to helping millions of people take control of their finances through expert guidance and innovative tools. A trusted platform for money management, credit education, and identity protection, our mission is to bring financial power to all.")) : null, footerDataUpdated().map(function (col, index) {
        return React.createElement(Accordion.Item, {
          eventKey: "".concat(index).concat(id),
          key: col.id
        }, React.createElement("p", {
          className: "d-none d-lg-block h7 text-secondary"
        }, col.column), React.createElement(Accordion.Button, {
          className: "d-lg-none mb-0 h7",
          id: "".concat(index).concat(id, "h"),
          "aria-controls": "".concat(index).concat(id)
        }, col.column), React.createElement(Accordion.Body, {
          as: "ul",
          "aria-describedby": "".concat(index).concat(id, "h"),
          id: "".concat(index).concat(id),
          className: "list-unstyled"
        }, col.links.map(function (link) {
          return React.createElement("li", {
            key: link.id
          }, React.createElement(CustomLink, _objectSpread({
            isLink: link.linkType === _this.props.pageType,
            href: "".concat(link.link)
          }, link === null || link === void 0 ? void 0 : link.attributes), parse(link.title)));
        })));
      })), React.createElement("div", {
        className: "d-lg-flex text-center text-lg-start mt-lg-5 py-6 justify-content-lg-between mid-wrapper"
      }, React.createElement("div", {
        className: "d-flex flex-wrap flex-xl-nowrap"
      }, React.createElement("div", {
        className: "d-lg-flex mb-4 mb-xl-0 pe-xl-7 w-100 w-xl-auto"
      }, React.createElement(Image, {
        src: "".concat(sharedLogosPath, "/logo-experian-dei.svg"),
        className: "me-lg-2 mb-2 mb-lg-0",
        width: "32",
        height: "32",
        alt: "Experian's Diversity logo.",
        lazyLoading: true,
        placeholder: placeholderDarker
      }), React.createElement("div", null, React.createElement("div", {
        className: "eyebrow-text"
      }, "Experian\u2019s Diversity, Equity and Inclusion"), React.createElement("a", {
        href: "/diversity/",
        "data-link-both": "dei|footer-banner"
      }, "Learn more how Experian is committed"))), React.createElement("div", {
        className: "d-lg-flex px-xl-0 w-100 w-xl-auto"
      }, React.createElement(Image, {
        src: "".concat(sharedLogosPath, "/logo-data-privacy.svg"),
        className: "me-lg-2 mb-2 mb-lg-0",
        width: "35",
        height: "20",
        alt: "Data privacy logo.",
        lazyLoading: true,
        placeholder: placeholderDarker
      }), React.createElement("div", null, React.createElement("div", {
        className: "eyebrow-text"
      }, "Data privacy"), React.createElement("a", {
        href: "https://consumerprivacy.experian.com",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Your privacy choices")))), React.createElement("div", null, React.createElement("div", {
        className: "d-lg-flex flex-lg-nowrap"
      }, React.createElement(TrustpilotWidget, null), React.createElement("div", {
        className: "app-badge d-flex justify-content-center mt-5 mt-lg-0 "
      }, React.createElement("a", {
        href: appStoreAppLink,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "d-block pe-2",
        "data-op": "IBF"
      }, React.createElement(Image, {
        width: "120",
        lazyLoading: true,
        height: "36",
        src: "".concat(sharedLogosPath, "/logo-app-badge-apple.svg"),
        alt: "Download from the Apple App Store.",
        placeholder: placeholderDarker
      })), React.createElement("a", {
        href: googlePlayAppLink,
        target: "_blank",
        rel: "noopener noreferrer",
        "data-op": "ABF",
        className: "d-block"
      }, React.createElement(Image, {
        width: "120",
        height: "36",
        lazyLoading: true,
        src: "".concat(sharedLogosPath, "/logo-badge-google-play.svg"),
        alt: "Get it on Google Play.",
        placeholder: placeholderDarker
      })))), React.createElement("ul", {
        className: "mt-5 mt-lg-4 d-flex list-unstyled mb-0 justify-content-center justify-content-lg-end"
      }, footerData.social.map(function (item, i) {
        return React.createElement("li", {
          key: item.id,
          className: "mb-0".concat(i !== footerData.social.length - 1 ? ' me-3' : '')
        }, React.createElement("a", {
          className: "btn btn-reset font-icon-size-lg",
          "aria-label": item.label,
          title: item.label,
          href: item.link,
          target: "_blank",
          rel: "noopener noreferrer"
        }, React.createElement("span", {
          className: item.icon,
          "aria-hidden": "true"
        })));
      })))), React.createElement("div", {
        className: "bottom-wrapper links-unstyled"
      }, React.createElement("ul", {
        className: "list-unstyled text-center d-lg-flex justify-content-lg-between"
      }, footerData.legal.map(function (item) {
        return React.createElement("li", {
          key: item.id
        }, React.createElement("a", _objectSpread(_objectSpread({
          href: item.link
        }, item.target && {
          target: item.target
        }), item.rel && {
          rel: item.rel
        }), item.title));
      }))), React.createElement("div", {
        className: "pb-5 pt-3 pb-md-7 pt-md-4",
        id: "footer-disclosures"
      }, this.props.disclosures ? this.props.disclosures : null, React.createElement("p", null, parse("\xA9 ".concat(new Date().getFullYear(), " Experian. All rights reserved."))), React.createElement("p", null, returnFootNote(), parse(trademark)))));
    }
  }]);
}(React.Component);
export { Footer as default };